<template>
  <v-app>
    <v-app-bar app color="white" light>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/mainLogo.png')"
          transition="scale-transition"
          width="120"
        />
      </div>

      <v-spacer></v-spacer>

      <!-- <v-btn to="/" text><span class="mr-2">All</span></v-btn> -->
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
